module.exports = __webpack_public_path__ + "static/media/y4.87aabc4a.png";